import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME } from '../reducer';
import ValueTable from './ValueTable';
import Chart from './Chart';
import Responsive from '../../../../common/responsive/Responsive';
import './Value.scss';
import Header from '../../common/Header';
import ValueTableRanking from './ValueTableRanking';
import ConstCommon from '../../common/Const';
import { REDUCER_NAME as CURRENT_REDUCER_NAME } from './reducer';

const LAST_TIME_RANGE = 10;

class Value extends React.Component {
  render() {
    const {
      component = {},
      investData: { valueInvestTable },
    } = this.props;
    const lastTimeRange = valueInvestTable.find(
      time => time.timeRange === LAST_TIME_RANGE,
    );

    return (
      <div className="fiinTradeStrategy value flex-fill d-flex flex-column">
        <Header
          firstStrName={'strategy.visNameHeader'}
          secondStrName={'strategy.highNameHeader'}
          title={'strategy.vis'}
          isShowCheckbox={true}
          color={ConstCommon.COLORVALUE}
          data={lastTimeRange}
        />

        <div className="d-flex flex-fill">
          <div className="d-flex flex-fill flex-column h-100 px-20">
            <div className="mb-10">
              <Responsive
                appendClassChild="d-flex flex-fill"
                appendClass="responsive-wrapper-strategy"
                component={{
                  ...component,
                  width: Math.max(component.width, 400),
                }}
                margin={10}
                offsetWidth={40}
                XS_SIZE={600}
                numColumnLgSize={2}
                numColumnMdSize={2}
                ratioWidthItem={[6, 4]}
              >
                {widthC => <Chart width={widthC} />}
                {() => <ValueTable />}
              </Responsive>
            </div>
            <div className="d-flex flex-fill mb-10">
              <ValueTableRanking />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  component: state[REDUCER_NAME].component,
  investData: state[CURRENT_REDUCER_NAME].investData,
});

export default connect(mapStateToProps)(Value);
